import UAParser from 'ua-parser-js'

export const getUserAgentProperties = () => {
  if (typeof window === 'undefined') return {}

  const userAgent = window.navigator.userAgent
  const ua = new UAParser(userAgent)
  const uaResults = ua.getResult()
  const device = uaResults?.device || {}

  return {
    browser: uaResults?.browser?.name,
    os: uaResults?.os?.name,
    user_agent: userAgent,
    dvce_type: device.type || 'desktop',
    dvce_ismobile: device.type === 'mobile',
    device_name: device?.model,
  }
}
